import {useSearchParams} from "react-router-dom";
import React from "react";
import {AllMarketComponent} from "./AllMarketComponent";

export default function AllMarketProvider() {
    const [searchParams, setSearchParams] = useSearchParams();

    const categoryId = searchParams.get('category_id');

    return <AllMarketComponent child_category_id={categoryId}/>
}
